import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MuiIconButton from '@mui/material/IconButton';
import MuiPopover from '@mui/material/Popover';
import { type JSX, useState } from 'react';
import { BlockPicker, ColorChangeHandler, ColorResult } from 'react-color';

import { ICON_COLOR_SQUARE } from 'Config/Icons';

const MAROON = '#800000';
const BROWN = '#9A6324';
const RED = '#e6194B';
const ORANGE = '#f58231';
const YELLOW = '#ffe119';
const LIME = '#bfef45';
const GREEN = '#3cb44b';
const PURPLE = '#911eb4';
const MAGENTA = '#f032e6';
const LAVENDER = '#dcbeff';
const CYAN = '#42d4f4';
const BLUE = '#4363d8';
const BEIGE = '#fffac8';
const GREY = '#a9a9a9';
const BLACK = '#000000';

export const COLOR_PALETTE = [
    [MAROON, BROWN, RED, ORANGE, YELLOW],
    [LIME, GREEN, PURPLE, MAGENTA, LAVENDER],
    [CYAN, BLUE, BEIGE, GREY, BLACK],
].flat();

interface ColorPickerProps {
    initialColor?: string;
    onColorChange: (color: string) => void;
    accessibilityTitle: string;
}

export const ColorPicker = (props: ColorPickerProps): JSX.Element => {
    const [color, setColor] = useState<string>(props.initialColor ? props.initialColor : '#fff');
    const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);

    const colorChangeHandler: ColorChangeHandler = (color: ColorResult) => {
        setColor(color.hex);
        props.onColorChange(color.hex);
    };

    return (
        <div>
            <div>
                <MuiIconButton aria-label={props.accessibilityTitle} sx={{ color: color }} onClick={(event) => setAnchorElement(event.currentTarget)}>
                    <div>
                        <FontAwesomeIcon icon={ICON_COLOR_SQUARE} />
                    </div>
                </MuiIconButton>
            </div>
            {/* The picker is rendered in a popover, portaled to the end of the document body, so that it isn't clipped by the bounds of a container with overflow set, namely the scrollable `ManageTagsModal`. */}
            <MuiPopover
                open={anchorElement !== null}
                anchorEl={anchorElement}
                onClose={() => setAnchorElement(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                // `BlockPicker` draws its own card and shadow, plus a triangle that sticks out above the card. Make the popover's paper invisible and leave room for the triangle.
                slotProps={{ paper: { sx: { backgroundColor: 'transparent', boxShadow: 'none', marginTop: '10px', overflow: 'visible' } } }}
            >
                <BlockPicker colors={COLOR_PALETTE} onChangeComplete={colorChangeHandler} color={color} />
            </MuiPopover>
        </div>
    );
};
